import { Colors } from '@ab-core/colors';
import styled from 'styled-components';

export const StyledTableRow = styled.tr`
    background-color: ${Colors.white};
    &:nth-child(odd) {
        background-color: ${Colors.backgroundShade};
    }
`;
